// Persiste a preferência "mostrar apenas ativos" por tela (monitors/automations/strategies).
// Necessário porque várias ações (start/stop/delete) fazem history.go(0) — um reload que
// zeraria o estado do componente. Default OFF (mostra tudo, pra não esconder itens).

const KEY_PREFIX = 'onlyActive:';

export function getOnlyActive(scope) {
    return localStorage.getItem(KEY_PREFIX + scope) === 'true';
}

export function setOnlyActive(scope, value) {
    localStorage.setItem(KEY_PREFIX + scope, value ? 'true' : 'false');
}
